import {MAX_API_PAGINATION_PAGE_NUMBER_LIMIT} from '../../common/network/apiConstants';

const SEARCH_LIST_PAGE_SIZE = 24;
const TOGGLED_SEARCH_PAGINATION_PAGE_NUMBER_LIMIT = 50;
const STATIC_SEARCH_PAGINATION_PAGE_NUMBER_LIMIT = MAX_API_PAGINATION_PAGE_NUMBER_LIMIT;

export {
  SEARCH_LIST_PAGE_SIZE,
  TOGGLED_SEARCH_PAGINATION_PAGE_NUMBER_LIMIT,
  STATIC_SEARCH_PAGINATION_PAGE_NUMBER_LIMIT,
};
